import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { FastAccessService } from "./fastaccess.service";
import { AuthService } from "projects/sepidz-web-framework/src/lib/services";
@Component({
  selector: "order-fast-access",
  templateUrl: "./fastaccess.component.html",
  styleUrls: ["./fastaccess.component.scss"],
  providers: [FastAccessService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FastAccessComponent {
  constructor(public fastaccessservcie: FastAccessService, public cd: ChangeDetectorRef) {
    this.fastaccessservcie.order.cd_FastAccess = cd;
  }
}
